import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ComunicacaoService {
  private acaoSubject = new Subject<any>();

  acao = this.acaoSubject.asObservable();

  /** Id da proposta que deve ser destacada na listagem (ex: ao clicar em uma notificação) */
  private propostaIdDestaqueSubject = new BehaviorSubject<string | null>(null);
  propostaIdDestaque$ = this.propostaIdDestaqueSubject.asObservable();

  /** Documento do credor a ser pré-preenchido no filtro da listagem (ex: ao clicar em uma notificação) */
  private documentoCredorFiltroSubject = new BehaviorSubject<string | null>(null);
  documentoCredorFiltro$ = this.documentoCredorFiltroSubject.asObservable();

  emitirAcao(acao: any) {
    this.acaoSubject.next(acao);
  }

  get propostaIdDestaque(): string | null {
    return this.propostaIdDestaqueSubject.value;
  }

  definirPropostaDestaque(propostaId: string | null): void {
    this.propostaIdDestaqueSubject.next(propostaId);
  }

  limparPropostaDestaque(): void {
    if (this.propostaIdDestaqueSubject.value !== null) {
      this.propostaIdDestaqueSubject.next(null);
    }
  }

  get documentoCredorFiltro(): string | null {
    return this.documentoCredorFiltroSubject.value;
  }

  definirDocumentoCredorFiltro(documento: string | null): void {
    this.documentoCredorFiltroSubject.next(documento);
  }

  limparDocumentoCredorFiltro(): void {
    if (this.documentoCredorFiltroSubject.value !== null) {
      this.documentoCredorFiltroSubject.next(null);
    }
  }
}
